import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "./firebase";
import Carousel from "./Carousel"; // Ensure the path to firebase.js is correct
import "../style/FileUpload.css";
import { X, CloudUpload, ArrowUp, ArrowLeft } from "lucide-react";
import FrameImage from "../assets/Frame.png";
import GroupImage from "../assets/Group 1218.png";
import shieldTickSafe from "../assets/shield-tick-safe.svg";
// import img from "../assets/Frame.png";
import img from "../assets/mainpage.lottie";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import mainPageLottie from "../assets/mainpage.lottie";
// Add this after your imports
import { LoadingOutlined } from '@ant-design/icons';

import {
  Modal,
  Button,
  Input,
  Checkbox,
  Spin,
  Typography,
  Divider,
  Tooltip,
  Progress, // added
} from "antd"; // Import Ant Design Modal, Button, Input, Checkbox, Spin, Divider, Tooltip, and Progress
// Replaced react-toastify to use Ant Design Modal for messages
import { InfoCircleOutlined, CloseOutlined } from "@ant-design/icons"; // Import Ant Design InfoCircleOutlined and CloseOutlined icons
import JSZip from "jszip"; // Import JSZip for file compression
import { motion } from "framer-motion"; // Import Framer Motion for animations
import { relative } from "path-browserify";
import { v4 as uuidv4 } from "uuid"; // Import UUID library
import image109 from "../assets/image109.png"; // Import Certification 1
import image110 from "../assets/image110.png"; // Import Certification 2
import image111 from "../assets/image111.png"; // Import Certification 3
import { uploadToS3, uploadBatchToS3 } from '../utils/s3Utils';
import LogsTable from './LogsTable';

const { Title, Text, Paragraph } = Typography; // Destructure Typography components

const FileUpload = () => {
  const location = useLocation();
  const email = location.state?.email || localStorage.getItem("email") || "";
  const [files, setFiles] = useState([]); // State for multiple files
  const [fileCount, setFileCount] = useState(0); // State for file count
  const [url, setUrl] = useState("");
  const [error, setError] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false); // State for modal visibility
  const [countdown, setCountdown] = useState(3); // State for countdown timer
  const [clientName, setClientName] = useState(""); // State for client name
  const [compress, setCompress] = useState(false); // State for compression checkbox
  const [isZipping, setIsZipping] = useState(false); // State for zipping process
  const [isLogoutModalVisible, setIsLogoutModalVisible] = useState(false); // added
  // Modal for messages (errors / info)
  const [messageModalVisible, setMessageModalVisible] = useState(false);
  const [messageModalTitle, setMessageModalTitle] = useState("");
  const [messageModalContent, setMessageModalContent] = useState("");
  const [messageModalType, setMessageModalType] = useState("info");
  // Add this with other state declarations
  const [isUploading, setIsUploading] = useState(false);
  const [uploadPercent, setUploadPercent] = useState(0); // new state for percentage
  const [uploadQueue, setUploadQueue] = useState([]); // Track queued uploads
  const [activeUploads, setActiveUploads] = useState([]); // Track active uploads
  const [uploadProgress, setUploadProgress] = useState({}); // Track progress for each upload
  const [logsModalVisible, setLogsModalVisible] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (email) {
      console.log("User email:", email);
    }
  }, [email]);

  useEffect(() => {
    if (error) {
      // show centered modal for errors instead of toast
      setMessageModalTitle("Error");
      setMessageModalContent(error);
      setMessageModalType("error");
      setMessageModalVisible(true);
    }
  }, [error]);


  // Add new state for folder name
  const [selectedFolder, setSelectedFolder] = useState(null);

  // helper: split array into chunks to avoid too many concurrent requests
  const chunkArray = (arr, size) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  };

  // Modify handleFileChange to handle folder selection
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    if (selectedFiles.length === 0) return;

    const folderName = e.target.webkitdirectory ? 
      selectedFiles[0].webkitRelativePath.split('/')[0] : null;

    // Always set as new files, no more queuing
    setFiles(selectedFiles);
    setFileCount(selectedFiles.length);
    setSelectedFolder(folderName);
    setIsSelectModalVisible(false);
  };

  // Inside your component
  const [isSelectModalVisible, setIsSelectModalVisible] = useState(false);

  const openSelectModal = () => {
    setIsSelectModalVisible(true);
  };

  const handleSelectFiles = () => {
    document.getElementById("fileInput").click();
    setIsSelectModalVisible(false);
  };

  const handleSelectFolder = () => {
    const folderInput = document.getElementById('folderInput');
    folderInput.webkitdirectory = true;
    folderInput.directory = true;
    folderInput.multiple = true;
    folderInput.click();
    setIsSelectModalVisible(false);
  };



  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.target.classList.add("drag-over");
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.target.classList.remove("drag-over");
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.target.classList.remove("drag-over");

    const droppedFiles = Array.from(e.dataTransfer.files);
    setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
    setFileCount((prevCount) => prevCount + droppedFiles.length);

    droppedFiles.forEach((file) => console.log(file.name, file.webkitRelativePath));
  };


  const handleDragDropClick = () => {
    document.getElementById("fileInput").click();
  };

  const handleRemoveFile = (index) => {
    const updatedFiles = files.filter((_, i) => i !== index);
    setFiles(updatedFiles);
    setFileCount(updatedFiles.length); // Update file count
  };



  // ...existing code...
  const handleUpload = async () => {
    if (!clientName.trim()) {
      setMessageModalTitle("Error");
      setMessageModalContent("Please enter client name");
      setMessageModalType("error");
      setMessageModalVisible(true);
      return;
    }

    const uploadId = uuidv4();
    const filesToUpload = [...files];
    const currentClientName = clientName; // Capture current client name
    
    // Clear the form for new uploads
    setFiles([]);
    setFileCount(0);
    setSelectedFolder(null);
    setClientName(''); // Clear client name for next upload

    try {
      setIsUploading(true);
      setActiveUploads(prev => [...prev, { 
        id: uploadId, 
        total: filesToUpload.length, 
        progress: 0,
        clientName: currentClientName,
        folderName: selectedFolder // Add folder name to upload info
      }]);

      const currentDate = new Date().toISOString().split('T')[0];
      const basePath = `da_upload/${currentDate}/${currentClientName}`;

      // Show upload progress modal
      setMessageModalTitle("Upload Progress");
      setMessageModalContent(`Uploading ${selectedFolder ? `folder '${selectedFolder}'` : 'files'} for client '${currentClientName}'`);
      setMessageModalType("info");
      setMessageModalVisible(true);
      // Remove the setTimeout to keep modal open

      // Start upload in background
      uploadFiles(uploadId, filesToUpload, basePath, currentClientName, currentDate);

    } catch (err) {
      console.error("Upload failed:", err);
      setError("Upload failed. Please try again.");
    }
  };

  // Add currentDate parameter to uploadFiles
  const uploadFiles = async (uploadId, files, basePath, clientName, currentDate) => {
    try {
      const effectiveEmail = email || localStorage.getItem("uploadEmail") || "";
      const { results, failures } = await uploadBatchToS3(
        files,
        basePath,
        (percent) => {
          setUploadProgress(prev => ({ ...prev, [uploadId]: percent }));
          setActiveUploads(prev => 
            prev.map(upload => 
              upload.id === uploadId ? { ...upload, progress: percent } : upload
            )
          );
        },
        10
      );

      // Process successful uploads and log them
      const uploadedFiles = results
        .filter(r => r.success)
        .map(r => ({
          fileName: r.file.name,
          filePath: r.url,
          folderName: r.file.webkitRelativePath ? r.file.webkitRelativePath.split('/')[0] : null
        }));

      // Log successful uploads
      const successChunks = chunkArray(uploadedFiles, 100);
      for (const chunk of successChunks) {
        const payload = chunk.map(file => ({
          email: effectiveEmail,
          fileName: file.fileName,
          clientName,
          filePath: file.filePath,
          folderName: selectedFolder,
          status: 'SUCCESS'
        }));
        try {
          await axios.post("https://files-upload.finkraftai.com/log-uploads", { entries: payload });
        } catch (err) {
          console.error("Batch logging (success) failed:", err);
        }
      }

      // Log failures
      const failureEntries = failures.map(failure => ({
        email: effectiveEmail,
        fileName: failure.file.name,
        clientName,
        filePath: failure.error,
        status: 'FAILED',
        folderName: selectedFolder
      }));

      if (failureEntries.length > 0) {
        const failureChunks = chunkArray(failureEntries, 100);
        for (const chunk of failureChunks) {
          try {
            await axios.post("https://files-upload.finkraftai.com/log-uploads", { entries: chunk });
          } catch (err) {
            console.error("Batch logging (failed) failed:", err);
          }
        }
      }

      // Send email notification if email is provided
      if (effectiveEmail && uploadedFiles.length > 0) {
        try {
          await axios.post("https://files-upload.finkraftai.com/send-email", {
            email: effectiveEmail,
            files: uploadedFiles
          });
        } catch (err) {
          console.error("Failed to send email notification:", err);
        }
      }

      // Remove from active uploads when done
      setActiveUploads(prev => prev.filter(upload => upload.id !== uploadId));
      
      // Show success message
      setMessageModalTitle("Upload Complete");
      setMessageModalContent(`Successfully uploaded ${uploadedFiles.length} files${failures.length > 0 ? `. ${failures.length} files failed.` : ''}`);
      setMessageModalType(failures.length > 0 ? "warning" : "success");
      setMessageModalVisible(true);
      setTimeout(() => setMessageModalVisible(false), 3000);

      // Process next in queue if any
      if (uploadQueue.length > 0) {
        const nextUpload = uploadQueue[0];
        setUploadQueue(prev => prev.slice(1));
        uploadFiles(
          nextUpload.id,
          nextUpload.files,
          `da_upload/${currentDate}/${nextUpload.clientName}`,
          nextUpload.clientName,
          currentDate
        );
      } else {
        setIsUploading(false);
      }
    } catch (error) {
      console.error("Background upload failed:", error);
      setMessageModalTitle("Upload Error");
      setMessageModalContent("Failed to upload files. Please try again.");
      setMessageModalType("error");
      setMessageModalVisible(true);
    }
  };

  // Modified ActiveUploadsDisplay
  const ActiveUploadsDisplay = () => (
    !messageModalVisible && (
      <div style={{ 
        position: 'fixed', 
        bottom: 20, 
        left: 20, 
        width: 400, // Increased width
        maxWidth: '90vw',
        backgroundColor: 'white',
        padding: 20,
        borderRadius: 12,
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        zIndex: 1000
      }}>
        <div style={{ marginBottom: 16, borderBottom: '1px solid #eee', paddingBottom: 12 }}>
          <h4 style={{ margin: 0, color: '#1f2937', fontSize: 16 }}>Active Uploads</h4>
        </div>
        {activeUploads.map(upload => (
          <div key={upload.id} style={{ marginBottom: 16, backgroundColor: '#f8fafc', padding: 12, borderRadius: 8 }}>
            <div style={{ marginBottom: 8 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                <span style={{ 
                  fontSize: 14, 
                  color: '#374151', 
                  fontWeight: 500 
                }}>
                  {upload.folderName ? `📁 ${upload.folderName}` : '📄 Files'}
                </span>
                <span style={{ 
                  fontSize: 14, 
                  color: '#374151',
                  backgroundColor: '#e5e7eb',
                  padding: '2px 8px',
                  borderRadius: 12,
                  fontWeight: 500
                }}>
                  {upload.progress}%
                </span>
              </div>
              <div style={{ fontSize: 13, color: '#6b7280', marginBottom: 8 }}>
                Client: {upload.clientName}
              </div>
              <div style={{ fontSize: 13, color: '#6b7280', marginBottom: 8 }}>
                {upload.total} {upload.total === 1 ? 'file' : 'files'}
              </div>
            </div>
            <Progress 
              percent={upload.progress} 
              size="small" 
              status={upload.progress === 100 ? "success" : "active"}
              strokeColor={{
                '0%': '#0891b2',
                '100%': '#0d9488',
              }}
              strokeWidth={8}
              trailColor="#e2e8f0"
            />
          </div>
        ))}
        {uploadQueue.length > 0 && (
          <div style={{ 
            marginTop: 12,
            padding: 12,
            backgroundColor: '#f1f5f9',
            borderRadius: 8,
            fontSize: 13,
            color: '#475569',
            display: 'flex',
            alignItems: 'center',
            gap: 8
          }}>
            <span style={{ fontWeight: 500 }}>Queue:</span>
            <span>{uploadQueue.length} upload{uploadQueue.length === 1 ? '' : 's'} pending</span>
          </div>
        )}
      </div>
    )
  );

  // Add new component for left corner display
  const LeftCornerDisplay = () => (
    <div style={{ 
      position: 'fixed', 
      bottom: 20, 
      left: 20,
      maxWidth: 300,
      backgroundColor: '#f0f9ff',
      padding: 12,
      borderRadius: 8,
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      zIndex: 1000,
      display: 'flex',
      alignItems: 'center',
      gap: 8
    }}>
      <div style={{ 
        width: 8, 
        height: 8, 
        borderRadius: '50%', 
        backgroundColor: '#0891b2',
        animation: 'pulse 2s infinite'
      }} />
      <span style={{ fontSize: 13, color: '#0891b2', fontWeight: 500 }}>
        {activeUploads.length} active upload{activeUploads.length !== 1 ? 's' : ''}
      </span>
    </div>
  );

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/"); // Navigate back to the login page
    } catch (err) {
      setError("Failed to log out. Please try again.");
    }
  };

  const handleOk = () => {
    setIsModalVisible(false);
    window.location.reload(); // Refresh the page on modal close
  };

  const handleBackClick = () => {
    // added
    setIsLogoutModalVisible(true);
  };

  const confirmLogout = async () => {
    // added
    try {
      try { localStorage.removeItem("uploadtoken"); } catch (e) {}
      try { localStorage.removeItem("uploadEmail"); } catch (e) {}
      // attempt firebase sign out if available
      if (auth && signOut) await signOut(auth);
      setIsLogoutModalVisible(false);
      navigate("/"); // Navigate back to the login page
    } catch (err) {
      setError("Failed to log out. Please try again.");
    }
  };

  const cancelLogout = () => {
    // added
    setIsLogoutModalVisible(false);
  };

  // Add this helper function
  const addToUploadQueue = (newFiles, folderName) => {
    const uploadId = uuidv4();
    const queueItem = {
      id: uploadId,
      files: newFiles,
      folderName,
      clientName: clientName, // Capture current client name
      progress: 0,
      status: 'queued',
      total: newFiles.length
    };
    setUploadQueue(prev => [...prev, queueItem]);
    setUploadProgress(prev => ({ ...prev, [uploadId]: 0 }));
    return uploadId;
  };

  const showLogsModal = () => setLogsModalVisible(true);
  const hideLogsModal = () => setLogsModalVisible(false);

  return (
    <div className="main-container">
      {/* Add LeftCornerDisplay when there are active uploads */}
      {/* {activeUploads.length > 0 && <LeftCornerDisplay />} */}
      
      {/* Update Modal to show full progress when open */}
      <Modal
        centered
        title={messageModalTitle}
        visible={messageModalVisible}
        width={600}
        onOk={() => setMessageModalVisible(false)}
        onCancel={() => setMessageModalVisible(false)}
        footer={[
          <Button
            key="ok"
            type="primary"
            onClick={() => setMessageModalVisible(false)}
            style={{
              backgroundColor: messageModalType === "error" ? "#EF4444" : "#008080",
              borderColor: messageModalType === "error" ? "#EF4444" : "#008080",
            }}
          >
            {messageModalTitle === "Upload Progress" ? "Continue in Background" : "OK"}
          </Button>,
        ]}
      >
        <div style={{ marginBottom: 16 }}>
          {messageModalTitle === "Upload Progress" ? (
            <>
              <Paragraph>{messageModalContent}</Paragraph>
              {activeUploads.map(upload => (
                <div key={upload.id} style={{ 
                  marginTop: 16,
                  padding: 16,
                  backgroundColor: '#f8fafc',
                  borderRadius: 8,
                  border: '1px solid #e2e8f0'
                }}>
                  {/* Enhanced upload display in modal */}
                  <div style={{ marginBottom: 12 }}>
                    <div style={{ 
                      fontWeight: 500, 
                      color: '#374151', 
                      marginBottom: 4,
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center'
                    }}>
                      <span>{upload.folderName ? `📁 ${upload.folderName}` : '📄 Files'}</span>
                      <span style={{
                        fontSize: 14,
                        backgroundColor: '#e5e7eb',
                        padding: '2px 8px',
                        borderRadius: 12
                      }}>{upload.progress}%</span>
                    </div>
                    <div style={{ fontSize: 13, color: '#6b7280', marginBottom: 4 }}>
                      Client: {upload.clientName}
                    </div>
                    <div style={{ fontSize: 13, color: '#6b7280' }}>
                      {upload.total} {upload.total === 1 ? 'file' : 'files'}
                    </div>
                  </div>
                  <Progress 
                    percent={upload.progress} 
                    status={upload.progress < 100 ? "active" : "success"}
                    strokeColor={{
                      '0%': '#0891b2',
                      '100%': '#0d9488',
                    }}
                  />
                </div>
              ))}
            </>
          ) : (
            <Paragraph>{messageModalContent}</Paragraph>
          )}
        </div>
      </Modal>

      {/* Add LogsTable component */}
      <LogsTable 
        visible={logsModalVisible} 
        onClose={hideLogsModal}
        activeUploads={activeUploads}
      />
      {/* Logout confirmation modal */}
      <Modal
        centered
        title="Confirm logout"
        visible={isLogoutModalVisible}
        onOk={confirmLogout}
        onCancel={cancelLogout}
        okText="Logout"
        cancelText="Cancel"
      >
        <p>Are you sure you want to logout? This will clear your session.</p>
      </Modal>
      
      {/* ...rest of existing JSX... */}
      <div className="image-container">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="235"
          height="51"
          viewBox="0 0 235 51"
          fill="none"
          className="svgicon"
        >
          <path
            d="M21.0208 34.2886H16.1038V13.8262H7.50808V34.2886H2.57733V13.8262H0V10.3217H2.57733V9.77966C2.57733 8.91156 2.57733 7.77706 2.66873 6.95948C3.12113 2.50414 6.06404 0.000887425 12.9826 0.000887425C14.0293 -0.0100823 15.0745 0.0806713 16.1038 0.271882V4.0015C10.0443 3.54219 8.00618 4.54809 7.64517 7.2167C7.5532 7.97872 7.50741 8.74565 7.50808 9.51326V10.3308H21.0208V34.2886Z"
            fill="#03A5B7"
          />
          <path
            d="M48.8207 20.6859V34.2886H43.8411V21.2502C43.8411 20.117 43.8411 19.071 43.7497 17.846C43.5256 15.1209 42.0761 13.2124 38.6832 13.2124C35.2904 13.2124 32.4325 15.9375 32.4325 23.4752V34.2886H27.4575V10.1707H32.4325V14.1666L34.0649 11.414C35.9671 9.95964 37.723 9.55133 40.1282 9.55133C45.2906 9.55133 48.2308 12.2306 48.6835 16.4559C48.7749 17.6625 48.8207 18.7544 48.8207 20.6859Z"
            fill="#03A5B7"
          />
          <path
            d="M85.1812 9.80549V10.7231C80.847 10.3561 77.8177 13.3109 77.8177 21.2119V34.2884H76.8276V10.3928H77.8177V15.527L78.7666 12.8016C79.9204 10.9274 81.9492 9.77904 84.141 9.75961C84.4883 9.75086 84.8359 9.76619 85.1812 9.80549Z"
            fill="#A3A6B7"
          />
          <path
            d="M103.455 28.4244L102.41 30.8329C100.734 33.5305 97.9216 34.9068 94.7016 34.9068C90.1671 34.9068 87.373 32.7735 87.373 28.4841C87.373 22.9009 94.4497 20.4924 101.884 20.4924H103.427V19.3087C103.427 18.171 103.427 17.2626 103.336 16.2167C103.019 12.6291 100.661 10.7115 96.7582 10.7115C93.4054 10.7115 89.8235 12.4823 89.2785 16.9323H88.28C88.5548 12.9365 92.045 9.75723 96.7582 9.75723C101.471 9.75723 104.013 12.0511 104.334 16.0698C104.426 17.2948 104.426 17.9324 104.426 19.2032V26.5435C104.426 29.2685 104.558 31.1311 104.833 34.2645H103.789L103.455 28.4244ZM103.409 24.791V21.5246C96.4238 21.0704 88.4586 23.0202 88.4586 28.4841C88.4586 31.8009 90.4968 33.9893 94.8711 33.9893C99.9598 33.9893 103.409 29.5163 103.409 24.8139V24.791Z"
            fill="#A3A6B7"
          />
          <path
            d="M112.288 6.79732V10.6308H117.124V11.5857H112.288V34.3571H111.31V11.572H108.734V10.6308H111.31V6.79732C111.3 5.99439 111.33 5.19144 111.402 4.39163C111.671 1.38911 113.685 0.0714961 115.512 0.0714961C116.227 0.0519306 116.941 0.12914 117.636 0.301046V1.25138C114.11 0.388276 112.612 2.11909 112.393 4.52477C112.318 5.27992 112.283 6.03848 112.288 6.79732Z"
            fill="#A3A6B7"
          />
          <path
            d="M127.908 33.6955V34.4942C127.147 34.5927 126.381 34.6387 125.614 34.6319C123.48 34.6319 122.346 33.6313 122.163 31.5427C122.071 30.4502 122.071 29.679 122.071 28.3294V11.4279H119.212V10.6246H122.071V5.70374H123.072V10.6246H127.775V11.4416H123.094V28.5268C123.094 29.8029 123.094 30.4823 123.14 31.1203C123.319 33.466 124.366 34.1959 127.908 33.6955Z"
            fill="#A3A6B7"
          />
          <path
            d="M134.686 32.7884C134.695 33.6679 134.173 34.4656 133.365 34.8064C132.557 35.1473 131.624 34.9636 131.004 34.3417C130.384 33.7198 130.201 32.7833 130.541 31.9725C130.881 31.1617 131.675 30.6379 132.552 30.6472C133.122 30.6345 133.672 30.856 134.075 31.2603C134.477 31.6647 134.698 32.2167 134.686 32.7884Z"
            fill="#03A5B7"
          />
          <path
            d="M165.5 6.83989C165.506 7.39403 165.158 7.89661 164.62 8.11139C164.082 8.32617 163.46 8.21043 163.047 7.81857C162.634 7.42671 162.513 6.83667 162.739 6.32581C162.965 5.81495 163.495 5.48488 164.078 5.49074C164.458 5.48274 164.824 5.6223 165.093 5.87707C165.361 6.13184 165.508 6.47968 165.5 6.83989Z"
            fill="#A3A6B7"
          />
          <path
            d="M164.602 33.9462L164.602 34.4149H164.106H163.539C163.539 34.4149 163.539 29.4938 163.539 28.2045V12.0576V11.5804H163.696H163.963H164.573V12.0708V28.3931C164.573 29.6122 164.555 33.1023 164.602 33.7119V33.9462Z"
            fill="#A3A6B7"
          />
          <path
            d="M154.991 28.3845L153.94 30.7717C152.254 33.4453 149.425 34.8094 146.186 34.8094C141.624 34.8094 138.814 32.6951 138.814 28.4436C138.814 22.9099 145.932 20.5228 153.41 20.5228H154.963V19.3496C154.963 18.222 154.963 17.3217 154.871 16.285C154.553 12.7292 152.18 10.8286 148.254 10.8286C144.882 10.8286 141.279 12.5837 140.73 16.9943H139.726C140.002 13.0339 143.513 9.88279 148.254 9.88279C152.996 9.88279 155.553 12.1563 155.875 16.1395C155.967 17.3535 155.967 17.9855 155.967 19.245V26.5202C155.967 29.2211 156.107 31.5199 156.383 34.6255H155.318L154.991 28.3845ZM154.945 24.7833V21.5458C147.918 21.0957 139.906 23.0281 139.906 28.4436C139.906 31.7311 141.956 33.9 146.356 33.9C151.475 33.9 154.945 29.4667 154.945 24.806V24.7833Z"
            fill="#A3A6B7"
          />
          <path
            d="M56.383 24.3728C56.3621 24.3918 56.3502 24.4187 56.3502 24.4469V33.9405C56.3502 33.9957 56.3054 34.0405 56.2502 34.0405H55.4594C55.4041 34.0405 55.3594 33.9957 55.3594 33.9405V1.19782C55.3594 1.14259 55.4041 1.09782 55.4594 1.09782H56.2502C56.3054 1.09782 56.3502 1.14259 56.3502 1.19782V23.012C56.3502 23.099 56.4536 23.1445 56.5177 23.0857L70.2704 10.4903C70.2888 10.4735 70.3129 10.4641 70.3379 10.4641H71.5262C71.6177 10.4641 71.6611 10.5767 71.5934 10.6381L59.2657 21.8227C59.2228 21.8616 59.2218 21.9287 59.2636 21.9689L71.6515 33.8684C71.7165 33.9307 71.6723 34.0405 71.5822 34.0405H70.3847C70.3589 34.0405 70.3341 34.0305 70.3155 34.0127L58.4446 22.6292C58.4067 22.5928 58.3471 22.592 58.3082 22.6273L56.383 24.3728Z"
            fill="#03A5B7"
          />
          <path
            d="M72.3437 13.1978L63.0362 21.9733C63.0046 22.0031 63.0039 22.053 63.0345 22.0837L63.4012 22.4506L72.3784 31.304C72.3928 31.3182 72.4122 31.3262 72.4325 31.3262H73.3592C73.4278 31.3262 73.4621 31.2433 73.4136 31.1948L64.3022 22.0836C64.2716 22.0531 64.2722 22.0034 64.3034 21.9735L73.3712 13.3095C73.4214 13.2615 73.3875 13.1768 73.318 13.1768H72.3965C72.3769 13.1768 72.358 13.1843 72.3437 13.1978Z"
            fill="#A3A6B7"
          />
        </svg>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            maxWidth: "90%",
          }}
        >
          <Carousel />
          <div
            className="certification-container"
            style={{
              marginTop: "20%",
            }}
          >
            {" "}
            <img
              style={{
                maxWidth: "10%",
              }}
              src={image109}
              alt="Certification 1"
              className="certification-logo"
            />{" "}
            <img
              style={{
                maxWidth: "20%",
              }}
              src={image110}
              alt="Certification 2"
              className="certification-logo"
            />{" "}
            <img
              style={{
                maxWidth: "10%",
              }}
              src={image111}
              alt="Certification 3"
              className="certification-logo"
            />{" "}
          </div>
        </div>

        {/* <Title level={1} style={{ "margin-left": "-49%", color: "#0A8394" }}>
          Quick File Upload
        </Title> */}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-evenly",
          backgroundColor: "#FFFFFF",
          borderRadius: "2vw",
          padding: "2vw 1.5rem",
          minHeight: "95%",
          minWidth: "30%",
          width: "80%",
          maxWidth: "30rem",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.05)",
          position: "relative", // Added to position the back icon
        }}
      >
        <div
          onClick={handleBackClick}
          style={{
            position: "absolute", // Change to absolute positioning
            top: "1rem", // Position from the top
            right: "1rem", // Position from the right
            cursor: "pointer", // Change cursor to pointer
          }}
        >
          <ArrowLeft size={24} color="#0A8394" />
        </div>
        <div
          style={{
            marginBottom: "1vw",
          }}
        >
          <h1
            style={{
              fontSize: "1.25rem",
              fontWeight: "500",
              marginBottom: "0.25rem",
              color: "#475569",
            }}
          >
            Welcome back,
          </h1>

          <h6
            style={{
              fontWeight: "400",
              color: "#0F172A",
            }}
          >
            File upload service
          </h6>
        </div>

        {/* File Selection Area */}
        {/* File Selection Area */}
        <div style={{ marginBottom: "1.5rem" }}>
          <div
            style={{
              border: "2px dashed #CBD5E1",
              borderRadius: "0.5rem",
              padding: "1vw",
              textAlign: "center",
              cursor: "pointer",
              backgroundColor: "#FFFFFF",
              transition: "border-color 0.2s ease",
            }}
            onClick={openSelectModal}
            onDragOver={handleDragOver}
            onDrop={handleDrop}
            onDragEnter={(e) => {
              e.preventDefault();
              e.currentTarget.style.borderColor = "#0891B2";
            }}
            onDragLeave={(e) => {
              e.preventDefault();
              e.currentTarget.style.borderColor = "#CBD5E1";
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "0.25rem",
              }}
            >
              <ArrowUp
                size={16}
                color="#6B7280"
                style={{ marginBottom: "0.5rem" }}
              />
              <span style={{ color: "#64748B" }}>
                Drag & Drop or{" "}
                <span style={{ color: "#0A8394", textDecoration: "underline" }}>
                  Choose File / Folder
                </span>{" "}
                to upload
              </span>
            </div>
          </div>

          {/* Hidden Inputs */}
          <input
            type="file"
            id="fileInput"
            multiple
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
          <input
            type="file"
            id="folderInput"
            webkitdirectory="true"
            multiple
            onChange={handleFileChange}
            style={{ display: "none" }}
          />

          {/* Tooltip */}
          <div
            style={{
              fontSize: "0.875rem",
              color: "#64748B",
              marginTop: "0.75rem",
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
            }}
          >
            <Tooltip
              title="Upload multiple files at once by selecting them or dragging and dropping"
              color="#0A8394"
              overlayInnerStyle={{
                padding: "8px 12px",
                fontSize: "0.813rem",
              }}
            >
              <InfoCircleOutlined
                style={{
                  color: "#0A8394",
                  fontSize: "1rem",
                  cursor: "pointer",
                }}
              />
            </Tooltip>
            Select one or more files or a folder
          </div>
        </div>
        {/* Modal for choosing File or Folder */}
        <Modal
          title="Upload Options"
          centered
          visible={isSelectModalVisible}
          onCancel={() => setIsSelectModalVisible(false)}
          footer={null} // We'll create custom buttons inside content
          bodyStyle={{ textAlign: "center", padding: "2rem" }}
          width={550}
          closable={true}
        >
          <p style={{ fontSize: "1rem", color: "#475569", marginBottom: "2rem" }}>
            Please select whether you want to upload individual <strong>files</strong> or an entire <strong>folder</strong>:
          </p>
          <div style={{ display: "flex", justifyContent: "space-around", gap: "1rem" }}>
            <Button
              type="primary"
              size="large"
              style={{
                backgroundColor: "#0A8394",
                borderColor: "#0A8394",
                flex: 1,
                fontWeight: 500,
                borderRadius: "0.5rem",
                padding: "0.5rem 0",
              }}
              onClick={handleSelectFiles}
            >
              Files
            </Button>
            <Button
              type="primary"
              size="large"
              style={{
                backgroundColor: "#0891B2",
                borderColor: "#0891B2",
                flex: 1,
                fontWeight: 500,
                borderRadius: "0.5rem",
                padding: "0.5rem 0",
              }}
              onClick={handleSelectFolder}
            >
              Folder
            </Button>
          </div>
          <Button
            style={{
              marginTop: "1.5rem",
              width: "100%",
              borderRadius: "0.5rem",
              border: "1px solid #CBD5E1",
              color: "#64748B",
              backgroundColor: "#FFFFFF",
              fontWeight: 500,
            }}
            onClick={() => setIsSelectModalVisible(false)}
          >
            Cancel
          </Button>
        </Modal>



        {/* Client Name Input */}
        <div style={{ marginBottom: "1.5rem" }}>
          <label
            style={{
              display: "block",
              color: "#64748B",
              fontSize: "0.875rem",
              marginBottom: "0.5rem",
            }}
          >
            Enter client name
          </label>
          <input
            style={{
              width: "100%",
              padding: "0.4rem 0.75rem",
              border: "1px solid #E2E8F0",
              borderRadius: "0.375rem",
              fontSize: "1rem",
              color: "#0F172A",
              transition: "border-color 0.2s ease",
              outline: "none",
            }}
            placeholder="Enter client name"
            value={clientName}
            onChange={(e) => setClientName(e.target.value)}
            onFocus={(e) => (e.target.style.borderColor = "#0891B2")}
            onBlur={(e) => (e.target.style.borderColor = "#E2E8F0")}
          />
        </div>

        {/* File List */}
        {/* File List */}
<div style={{ marginBottom: "1.5rem" }}>
  <label
    style={{
      display: "block",
      color: "#64748B",
      fontSize: "0.875rem",
      marginBottom: "0.5rem",
    }}
  >
    {selectedFolder ? `Selected folder:` : 'Selected files'}
  </label>

  <div
    style={{
      backgroundColor: "#F8FAFC",
      borderRadius: "0.375rem",
    }}
  >
    {files.length === 0 ? (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "5rem",
          fontSize: "0.875rem",
          color: "#64748B",
        }}
      >
        {selectedFolder ? 'No files in folder' : 'No files selected'}
      </div>
    ) : (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          maxHeight: "12rem",
          overflowY: "auto",
          gap: "0.25rem",
          padding: "0.25rem",
        }}
      >
        {/* Show only folder name if folder selected */}
        {selectedFolder ? (
          <div
            style={{
              padding: "0.5rem 0.75rem",
              backgroundColor: "#E2E8F0",
              borderRadius: "0.25rem",
              marginBottom: "0.25rem",
            }}
          >
            <span style={{ color: "#475569", fontSize: "0.875rem" }}>
              📁 {selectedFolder} ({files.length} files)
            </span>
          </div>
        ) : (
          /* Show individual file names if files selected */
          files.map((file, index) => (
            <div
              key={index}
              style={{
                padding: "0.5rem 0.75rem",
                backgroundColor: "#FFFFFF",
                border: "1px solid #E2E8F0",
                borderRadius: "0.25rem",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: "0.875rem",
                color: "#475569",
              }}
            >
              <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                📄 {file.name}
              </span>
              <span style={{ fontSize: "0.75rem", color: "#64748B" }}>
                {(file.size / 1024).toFixed(1)} KB
              </span>
            </div>
          ))
        )}
      </div>
    )}
  </div>

  {files.length > 0 && (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        marginTop: "0.5rem",
        padding: "0.25rem 0.5rem",
        color: "#64748B",
        fontSize: "0.75rem",
      }}
    >
      <span>Total files: {files.length}</span>
      <span>
        Total size: {(files.reduce((acc, file) => acc + file.size, 0) / 1024).toFixed(1)} KB
      </span>
    </div>
  )}
</div>




        {/* Compress Option */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
            marginBottom: "1.5rem",
          }}
        >
          <input
            type="checkbox"
            id="compress"
            checked={compress}
            onChange={(e) => setCompress(e.target.checked)}
            style={{
              width: "0.75rem", // decreased from 1rem
              height: "0.75rem", // decreased from 1rem
              cursor: "pointer",
            }}
          />
          <label
            htmlFor="compress"
            style={{
              color: "#64748B",
              fontSize: "0.875rem",
              cursor: "pointer",
            }}
          >
            Compress into ZIP file.
          </label>
        </div>

        {/* Upload Button */}
        <button
          onClick={handleUpload}
          disabled={files.length === 0 || !clientName.trim()} // Only disable if no files or no client name
          style={{
            width: "100%",
            padding: "0.4rem 0.75rem",
            backgroundColor: files.length === 0 || !clientName.trim() ? "#94A3B8" : "#0A8394",
            color: "#FFFFFF",
            border: "none",
            borderRadius: "0.375rem",
            cursor: files.length === 0 || !clientName.trim() ? "not-allowed" : "pointer",
            fontSize: "1rem",
            fontWeight: "500",
            transition: "background-color 0.2s ease",
            outline: "none",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onMouseEnter={(e) => {
            if (files.length > 0 && clientName.trim()) {
              e.currentTarget.style.backgroundColor = "#0E7490";
            }
          }}
          onMouseLeave={(e) => {
            if (files.length > 0 && clientName.trim()) {
              e.currentTarget.style.backgroundColor = "#0891B2";
            }
          }}
        >
          <CloudUpload size={16} style={{ marginRight: "0.5rem" }} />
          Upload files
        </button>
      </div>
      {/* {(activeUploads.length > 0 || uploadQueue.length > 0) && <ActiveUploadsDisplay />} */}

      {/* Add Logs button after the client name input */}
      <div style={{ 
        position: 'absolute',
        top: '1rem',
        right: '3rem', // Position it next to the back button
      }}>
        <Button
          type="primary"
          onClick={showLogsModal}
          style={{
            backgroundColor: '#0A8394',
            borderColor: '#0A8394',
          }}
        >
          View Logs
        </Button>
      </div>
    </div>
  );
};

export default FileUpload;
